import {
    createFileRoute,
    redirect,
} from '@tanstack/react-router'

import {
    ApiError,
} from '@/shared/api'

import {
    currentUserQuery,
} from '@/features/authentication/queries'

import {
    LoginPage,
} from '@/features/authentication/pages'


interface LoginSearch {
    mode?: 'reset-password'
    userName?: string
    token?: string
}


export const Route =
    createFileRoute('/authentication/login')({

        validateSearch: (
            search: Record<string, unknown>,
        ): LoginSearch => ({
            mode:
                search.mode === 'reset-password'
                    ? 'reset-password'
                    : undefined,

            userName:
                typeof search.userName === 'string'
                    ? search.userName
                    : undefined,

            token:
                typeof search.token === 'string'
                    ? search.token
                    : undefined,
        }),

        beforeLoad: async ({
            context,
            search,
        }) => {

            // Allow a valid password-reset link
            // even if the browser currently has
            // an authenticated session.
            if (
                search.mode === 'reset-password' &&
                search.userName &&
                search.token
            ) {
                return
            }

            try {
                await context.queryClient.fetchQuery(
                    currentUserQuery,
                )

                throw redirect({
                    to: '/',
                })
            }
            catch (error) {
                if (
                    error instanceof ApiError &&
                    error.isUnauthorized
                ) {
                    return
                }

                throw error
            }
        },

        component: LoginPage,
    })